import { Component, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'aa-view-ch2',
    templateUrl: './view-ch2.component.html',
    styleUrls: [
        './view-ch2.component.scss'
    ],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ViewCh2Component
{
}
